var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex flex-grow-1"},[_c('PresentationControl'),_vm._v(" "),_c('SideBar',{staticClass:"d-flex flex-grow-1 bg-dark"}),_vm._v(" "),_c('ConnectionIndicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }